import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Availability from './views/Availability'
import Contact from './views/Contact'
import Facilities from './views/Facilities'
import About from './views/About'
import BarMenu from './views/BarMenu'
import Rooms from './views/Rooms'
import Packages from './views/Packages'
import PackageDetails from './views/PackageDetails'
import store from './store'

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    linkActiveClass: 'active',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/rooms',
            name: 'rooms',
            component: Rooms
        },
        {
            path: '/packages',
            name: 'packages',
            component: Packages
        },
        {
            path: '/packages/:id',
            name: 'packageDetails',
            component: PackageDetails
        },
        {
            path: '/facilities',
            name: 'facilities',
            component: Facilities
        },
        {
            path: '/availability',
            name: 'availability',
            component: Availability
        },
        {
            path: '/contact',
            name: 'contact',
            component: Contact
        },
        {
            path: '/about',
            name: 'about',
            component: About
        },
        {
            path: '/menu',
            name: 'menu',
            component: BarMenu
        },
    ]
})

export default router
